module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-200-light-eba2c98c309305d27cd526e0cc9040d7.woff2";